import { Fragment } from 'react';
import cn from 'classnames';

import { defineTheme, type ThemeKeys } from 'js/utils/theme-helpers';

import Link from 'components/link/Link';

import { IMetadata } from 'source/NFR.types';

const themes = defineTheme({
  vertical: 'metadata--theme-vertical',
  verticalVacancies: 'metadata--theme-vertical metadata--theme-vertical-vacancies'
});
export type MetadataTheme = ThemeKeys<typeof themes>;

interface MetadataProps extends IMetadata {
  theme?: MetadataTheme;
}

const Metadata: React.FC<MetadataProps> = ({ items = [], theme }) => {
  return (
    <dl className={cn('metadata', themes(theme))}>
      {items?.map(item => (
        <Fragment key={item.label + item.text}>
          <div className="metadata--item">
            <dt>{`${item.label}:`}</dt>
            <dd
              className={cn({
                'metadata--data--disabled': item.isDisabled
              })}
            >
              {item.url ? <Link url={item.url} text={item.text} /> : item.text}
            </dd>
          </div>
        </Fragment>
      ))}
    </dl>
  );
};

Metadata.displayName = 'Metadata';

export default Metadata;
